import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { zIndex, colors, fontFamily, breakpoints } from '../../ui/variables';

export const SupportStyle = styled.main`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.gray};
  box-sizing: border-box;
  min-width: 280px;
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone}px 52px;
  width: 100%;

  @media (min-width: ${breakpoints.wxgaPlus.width}px) {
    padding: calc(${headerVariables.main.height.iphone}px + 34px) 100px;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;
  }

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone}px;
    }
  }

  .contact-info {
    border-radius: 13px;
    margin: 25px 0;
    background-color: ${colors.mostlyWhite};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 312px;
    width: 100%;
    max-width: 577px;
    padding: 30px;

    .contact-box-title {
      ${fontFamily.sourceSansPro.bold};
    }

    .email-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      word-break: break-all;

      svg {
        fill: ${colors.grayishBlue};
        height: 14px;
        width: 20px;
        margin-right: 10px;
      }
    }

    .phone-container {
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      .phone-number-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 40px;
      }
      svg {
        fill: ${colors.grayishBlue};
        height: 17px;
        width: 17px;
        margin-right: 10px;
      }
    }

    .address-container {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin-top: 10px;

      .text-address {
        word-break: keep-all;
        max-height: 115px;
        min-width: 115px;
        width: 80%;
      }
      svg {
        fill: ${colors.grayishBlue};
        height: 17px;
        width: 14px;
        margin-right: 10px;
      }
    }
  }

  .support-form {
    position: relative;
    max-width: 580px;
    height: 800px;
    max-height: 800px;
    width: 100%;
    padding: 20px;
    .support-form-text {
      text-align: left;

      .support-text-title {
        ${fontFamily.sourceSansPro.bold};
      }

      .support-text {
        word-break: keep-all;
        margin-top: 13px;
        margin-bottom: 22px;
      }
    }

    .input-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 10px;
      height: 75px;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }

      .select-container {
        width: 100%;
      }

      .label-input {
        width: 100%;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          width: 30%;
        }
      }

      textarea {
        height: 100px;
        width: 70px;
      }
    }

    .input-container {
      margin-top: 10px;
      .add-image-container {
        border: dashed 1px ${colors.softBlue};
        margin-top: 10px;
        border-radius: 12px;
        margin-bottom: 40px;
        width: 100%;
        padding: 36px 0;
        position: relative;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          margin-top: 50px;
        }

        .add-image {
          .icon {
            display: block;
            height: 28px;
            left: 32px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 28px;

            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              height: 36px;
              left: 52px;
              width: 36px;
            }

            svg {
              fill: ${colors.softBlue};
            }
          }

          .form-instruction {
            ${fontFamily.sourceSansPro.bold};
            color: ${colors.softBlue};
            font-size: 16px;
            line-height: 20px;
            text-align: center;
          }

          .input-file-extension {
            ${fontFamily.sourceSansPro.regular};
            color: ${colors.softBlue};
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }

          .input-file {
            display: block;
            height: 100%;
            left: 0;
            opacity: 0;
            position: absolute;
            top: 0;
            width: 100%;
          }
        }
      }
    }

    .submit-button-container {
      bottom: 0;
      right: 0;
      position: absolute;
      width: 60%;
    }
  }
`;
